import styled from 'styled-components';
import { ReactComponent as Refresh } from '../../../../assets/icons/refresh.svg';

interface LXRefreshButtonProps {
  onClick: () => void;
}

const LXRefreshInnerButton = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  cursor: pointer;
  border-radius: 300px;
  background-color: ${(props) => props.theme.colors.grayBgDark};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

const LXRefreshButton = (props: LXRefreshButtonProps) => {
  return (
    <LXRefreshInnerButton onClick={props.onClick}>
      <Refresh></Refresh>
    </LXRefreshInnerButton>
  );
};

export default LXRefreshButton;
